export const FETCH_PAYMENT_METHODS_TYPE = 'PAYMENTS/FETCH_PAYMENT_METHODS'
export const SET_PAYMENT_METHODS_TYPE = 'PAYMENTS/SET_PAYMENT_METHODS_TYPE'
export const SET_PAYMENT_METHODS_LOADING_TYPE = 'PAYMENTS/SET_PAYMENT_METHODS_LOADING_TYPE'
export const SET_PAYMENT_METHODS_ERROR_TYPE = 'PAYMENTS/SET_PAYMENT_METHODS_ERROR_TYPE'
